const getTimeRemaining = (endtime) => {
  const ms = Date.parse(endtime) - Date.parse(new Date().toISOString());
  const seconds = ms > 0 ? Math.floor((ms / 1000) % 60) : 0;
  const minutes = ms > 0 ? Math.floor((ms / 1000 / 60) % 60) : 0;
  const hours = ms > 0 ? Math.floor((ms / (1000 * 60 * 60)) % 24) : 0;
  const days = ms > 0 ? Math.floor(ms / (1000 * 60 * 60 * 24)) : 0;

  return {
    ms,
    days,
    hours,
    minutes,
    seconds,
  };
}

const addLeadingZero = (num) => `0${num}`.slice(-2);

export default function initCountdown() {
  const $container = document.querySelector('.cp-countdown-banner');

  if (!$container) {
    return;
  }

  const clock = $container.querySelector('.js-countdown-banner');
  if (!clock) {
    return;
  }

  const endtime = new Date(Date.parse(clock.getAttribute('data-date-deadline')));
  const daysSpan = clock.querySelector('.days');
  const hoursSpan = clock.querySelector('.hours');
  const minutesSpan = clock.querySelector('.minutes');
  const secondsSpan = clock.querySelector('.seconds');
  let timeinterval = null;

  const start = () => {
    if (timeinterval !== null) return;
    timeinterval = setInterval(render, 1000);
  }

  const stop = () => {
    if (timeinterval === null) return;
    clearInterval(timeinterval);
    timeinterval = null
  }

  const render = () => {
    const t = getTimeRemaining(endtime);
    daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = addLeadingZero(t.hours);
    minutesSpan.innerHTML = addLeadingZero(t.minutes);
    secondsSpan.innerHTML = addLeadingZero(t.seconds);

    if (t.ms <= 0) {
      stop();
    }
  }

  start();
}
